import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { IsLoadingComponent } from '@interserve/igx-angular'
// import { AuthService } from 'src/app/services/auth.service'
import { AccountInfo } from 'interserve-commons'
import { FormsModule } from '@angular/forms'
import { TitleComponent } from 'src/app/components/title/title.component'
import { MasterService } from 'src/app/services/master.service'
// import { IsAuthorizationService } from '@interserve/angular'
// import { MasterService } from 'src/app/services/master.service'

@Component({
    selector: 'app-top',
    standalone: true,
    imports: [CommonModule, FormsModule, RouterOutlet, IsLoadingComponent, TitleComponent],
    templateUrl: './top.component.html',
    styleUrl: './top.component.scss',
})
export class TopComponent {
    public title = 'Document Wbs Top'
    public account!: AccountInfo
    public loading = false
    private root: any[] = []
    public navItems: any[] = []
    public garageId = ''

    constructor(
        // private authService: AuthService,
        private masterService: MasterService,
        private router: Router // private isAuthorizationService: IsAuthorizationService, // private masterService: MasterService
    ) {
        this.root = JSON.parse(JSON.stringify(router.config.filter((x) => x.title !== undefined)))
    }

    async ngOnInit(): Promise<void> {
        this.loading = true
        //★★権限まだ
        // this.garageId = this.authService.GarageId
        // let tmp = structuredClone(this.masterService.Menu)
        // tmp = this.mergeData(tmp, this.root)
        // this.navItems = tmp.filter((x: { title: string }) => x.title !== 'Top')
        this.navItems = this.masterService.Menu.filter((x: { title: string }) => x.title !== 'Top')

        this.loading = false
    }
    async clickCard(item: any) {
        this.router.navigate([`${item.path}`])
    }

    checkAuthorization(item: any): boolean {
        //★★権限まだ
        // if (!item.data || !item.data.authorizationKey) return true
        // return this.isAuthorizationService.checkAuthorization(item.data.authorizationKey)
        return true
    }

    //MenuデータとRootデータ（権限制御が入ってる）をマージ
    mergeData(data1: any[], data2: any[]): any[] {
        for (let item1 of data1) {
            for (let item2 of data2) {
                if (item1.path === item2.path) {
                    if (item2.data !== undefined) {
                        item1.data = item2.data
                    }
                    if (item2.canActivate !== undefined) {
                        item1.canActivate = item2.canActivate
                    }
                }
                if (item1.children && Array.isArray(item1.children)) {
                    item1.children = this.mergeData(item1.children, data2)
                }
            }
        }
        return data1
    }
}
